import {_BASIC_TRANSACTIONS ,TOGGLE_RESPONSES_LIST, SELECT_RESPONSE, SELECT_STEP,
        PURCHASE_CORRECTION_SUCCESS, PURCHASE_SUCCESS, PREAUTH_COMPLETION_SUCCESS, PREAUTH_SUCCESS,
        FORCE_POST_SUCCESS, REFUND_SUCCESS, INDEPENDENT_REFUND_SUCCESS, OPEN_TOTALS_SUCCESS,
        BATCH_CLOSE_SUCCESS, CARD_VERIFICATION_SUCCESS } from '../../actions/types'

const initialState = {
    selection: 1,
    isOpen: false
}

// eslint-disable-next-line
export default function(state = initialState, action) {
    if(action.feature === _BASIC_TRANSACTIONS) {
        switch(action.type) {
            case TOGGLE_RESPONSES_LIST:
                return { ...state, isOpen: !state.isOpen }
            case SELECT_RESPONSE:
                return { ...state, selection: action.payload, isOpen: false }
            case SELECT_STEP:
                return { ...state, selection: action.payload }
    
            case PURCHASE_SUCCESS:
                return { ...state, selection: 1 }
            case PREAUTH_SUCCESS:
                return { ...state, selection: 2 }
            case PREAUTH_COMPLETION_SUCCESS:
                return { ...state, selection: 3 }
            case FORCE_POST_SUCCESS:
                return { ...state, selection: 4 }
            case PURCHASE_CORRECTION_SUCCESS:
                return { ...state, selection: 5 }
            case REFUND_SUCCESS:
                return { ...state, selection: 6 }
            case INDEPENDENT_REFUND_SUCCESS:
                return { ...state, selection: 7 }
            case CARD_VERIFICATION_SUCCESS:
                return { ...state, selection: 8}
            case BATCH_CLOSE_SUCCESS:
                return { ...state, selection: 9 }
            case OPEN_TOTALS_SUCCESS:
                return { ...state, selection: 10 }
            
            default:
                return state
        }
    }
    else {
        return state
    }
}